import React from 'react';
import { FormattedMessage } from 'react-intl';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { history } from '../../configuration/store';
import InvoicesList from './invoicesList';
import { getInvoices } from '../../reducers/invoices';

class InvoicesPage extends React.Component {
    componentDidMount() {
        const { role, getInvoices } = this.props;
        getInvoices(role);
    }

    render() {
        const { role, invoices } = this.props;

        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>{InvoicesPage.meta.label}</h4>
                    </div>
                    <div className="col-xs-12">
                        <InvoicesList invoices={invoices} role={role} canGenerateDoc={role.type === 'admin'} />
                    </div>
                </div>
            </div>
        );
    }
}

InvoicesPage.meta = {
    label: <FormattedMessage id={'invoices'} defaultMessage={'Invoices'} />,
    icon: 'local_atm',
    action: () => history.push('/invoices'),
    locations: ['/invoices']
};

const mapStateToProps = state => ({
    role: state.identity.role,
    invoices: state.invoices.list
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getInvoices
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesPage);



// WEBPACK FOOTER //
// ./src/pages/invoices/index.jsx